var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMiniApp = function SvgMiniApp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 130,
    height: 80
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M0 0h53v80H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61 7h32a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H61a2 2 0 0 1-2-2V9c0-1.1.9-2 2-2z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 58a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H61a2 2 0 0 1-2-2V60c0-1.1.9-2 2-2h11zm-5.5 3c-1.6 0-3.4 1.3-3.5 2.8V65h-1v5h9v-5h-1v-1c0-1.7-1.8-3-3.5-3zm33.5 5a1 1 0 1 1 0 2H79a1 1 0 0 1 0-2h21zm-33.5-3c.5 0 1.4.4 1.5.9V65h-3v-1c0-.6 1-1 1.5-1zm55.5-1a1 1 0 1 1 0 2H79a1 1 0 0 1 0-2h43zM72 40a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H61a2 2 0 0 1-2-2V42c0-1.1.9-2 2-2h11zm-3 4.5L65.6 48l-2-2-1.5 1.3 3.5 3.6 5-5-1.4-1.4zm31 3.5a1 1 0 1 1 0 2H79a1 1 0 0 1 0-2h21zm22-4a1 1 0 1 1 0 2H79a1 1 0 0 1 0-2h43zM72 22a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H61a2 2 0 0 1-2-2V24c0-1.1.9-2 2-2h11zm-5.7 3L65 27.7l-3 .4 2.1 2-.5 3 2.7-1.4 2.6 1.4-.5-3 2.2-2-3-.4-1.3-2.7zm33.7 5a1 1 0 1 1 0 2H79a1 1 0 0 1 0-2h21zm22-4a1 1 0 1 1 0 2H79a1 1 0 0 1 0-2h43z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103 7h18a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-18a2 2 0 0 1-2-2V9c0-1.1.9-2 2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M52 0h1v80h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 64a3 3 0 1 1 0 6 3 3 0 0 1 0-6zm34 2a1 1 0 0 1 0 2H21a1 1 0 0 1 0-2h24zM11 50l3 6H8l3-6zm34 2a1 1 0 0 1 0 2H21a1 1 0 0 1 0-2h24zM11 36a3 3 0 1 1 0 6 3 3 0 0 1 0-6zm34 2a1 1 0 0 1 0 2H21a1 1 0 0 1 0-2h24zM13 22c.6 0 1 .4 1 1v4c0 .6-.4 1-1 1H9a1 1 0 0 1-1-1v-4c0-.6.4-1 1-1h4zm32 2a1 1 0 0 1 0 2H21a1 1 0 0 1 0-2h24z",
    opacity: 0.5
  }))));
};
export default SvgMiniApp;